import { faExclamationCircle, faPauseCircle, faPlayCircle } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import useCampaignPortal from '@hooks/useCampaignPortal'
import useCampaignSelector from '@hooks/useCampaignSelector'

import renderPortalStatusText from '@functions/portal'

import type { CampaignPortalModel } from '@models/types'

const renderIcon = (params: { isSyncing: boolean, lastSyncFailed: boolean }) => {
  const { isSyncing, lastSyncFailed } = params

  if (lastSyncFailed){
    return (
      <Checkbox
        checked
        color="red"
        iconChecked={faExclamationCircle}
      />
    )
  }

  return (
    <Checkbox
      checked
      color={isSyncing ? 'green' : 'orange'}
      iconChecked={isSyncing ? faPlayCircle : faPauseCircle}
    />
  )
}

interface ActivePortalListItemProps {
  campaignPortal: CampaignPortalModel,
}

const ActivePortalListItem = (props: ActivePortalListItemProps) => {
  const { campaignPortal } = props

  const {
    callbacks: { editCampaignPortal },
    campaignPortal: { last_sync_failed: lastSyncFailed, outgoing_agent_id, portal_id },
    lastSyncDateObj,
    portal,
  } = useCampaignPortal(campaignPortal)

  const { campaign } = useCampaignSelector()

  const isSyncing = campaign.published

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      onClick={() => editCampaignPortal()}
      showAngleIcon
    >
      {renderIcon({ isSyncing, lastSyncFailed })}

      <Box flexDirection="column">
        {/*
         // @ts-expect-error TS2339 */}
        <Text fontSize="small">{portal.title || `Portal #${portal_id}`}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {renderPortalStatusText({ isSyncing, lastSyncDateObj, lastSyncFailed })}
        </Text>
      </Box>

      <Box
        flexDirection="column"
        justifyContent="flex-end"
        marginLeft="auto"
        textAlign="right"
      >
        {!!outgoing_agent_id && (
          <Text fontSize="small" marginBottom="medium">
            {`Outgoing Agent ID ${outgoing_agent_id}`}
          </Text>
        )}

        {!!portal_id && (
          <Text color="bodyFontLightColor" fontSize="xsmall">
            {`Portal #${portal_id}`}
          </Text>
        )}
      </Box>
    </ListItem>
  )
}

export default ActivePortalListItem
